import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/Olive_Green_Fresh_Florals.svg")